
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notice/[id]",
      function () {
        return require("private-next-pages/notice/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/notice/[id]"])
      });
    }
  